import { getRequest } from '../utils'

export const getDesignForces: RequestTypeVariable = {
  getKey: id => ['getDesignForces', id],
  request: async (
    id: string,
    signal: AbortSignal,
  ): Promise<CombinedDesignSupportForcesOnPosition> => {
    const { data } = await getRequest<CombinedDesignSupportForcesOnPosition>({
      url: `/projects/${id}/design-support-forces`,
      signal,
    })

    return data as CombinedDesignSupportForcesOnPosition
  },
}
